<!-- custom-paginator.component.html -->
<div class="ara-paginator" *transloco="let t" #araPaginator>
	<mat-paginator
		#paginator
		[length]="length()"
		[pageIndex]="pageIndex()"
		[pageSizeOptions]="pageSizeOptions()"
		[pageSize]="pageSize()"
		[showFirstLastButtons]="showFirstLastButtons()"></mat-paginator>
	@if (maxPage() !== 0) {
		<mat-label class="mr-2">{{ t('araPaginator.pageIndex') }}</mat-label>
		<input
			class="border border-black/[.24] rounded-sm w-12 h-7"
			id="pageIndex"
			type="number"
			min="1"
			[value]="paginator.pageIndex + 1"
			(change)="onInputChange($event)" />
		<mat-label class="mx-1">/{{ maxPage() }}</mat-label>
	}
</div>
